import React from 'react';
import { ProductTourPopover } from './tourCard';

export function ProductTourRoot() {
  return <ProductTourPopover />;
}
